angular.module("vgresiduos").controller("CreateSupplierDocumentCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/fornecedores/${$stateParams.supplierCode}/documento`, [
				{ key: "docType", value: $stateParams.docType },
				{ key: "supDocId", value: $stateParams.supDocId },
				{ key: "requestId", value: $stateParams.requestId },
				{ key: "replacedDocumentId", value: $stateParams.replacedDocumentId },
				{ key: "originFilePath", value: $stateParams.originFilePath },
				{ key: "description", value: $stateParams.description },
				{ key: "number", value: $stateParams.number },
				{ key: "initialDate", value: $stateParams.initialDate },
				{ key: "expirationDate", value: $stateParams.expirationDate },
				{ key: "protocolNumber", value: $stateParams.protocolNumber },
				{ key: "protocolDate", value: $stateParams.protocolDate }
			]);
		};
	}
]);
